import React from 'react'
import classNames from 'classnames'
import { t } from 'i18next'
import { Heading, IllustrationName } from '@pandiafi/design-system'

import { ResidentAppIllustration } from 'components/ResidentAppIllustration'

interface ErrorProps {
  title?: string
  message?: string
  illustration?: IllustrationName
  eventId?: string
  action?: React.ReactNode
  className?: string
}

export const Error: React.FC<ErrorProps> = ({
  title,
  message,
  action,
  eventId,
  illustration = 'house-unhappy',
  className,
}) => {
  return (
    <main
      className={classNames(
        'text-brand-6 grid min-h-full place-items-center bg-white py-24 px-6 min-tablet:py-16 desktop:px-8',
        className
      )}
    >
      <ResidentAppIllustration
        name={illustration}
        className="mb-8 -ml-2 max-h-48 h-48"
        alt={t('common:alt.illustration')}
      />
      <div className="text-center">
        <div className="space-y-4">
          {title && (
            <Heading element="h1" size="l">
              {title}
            </Heading>
          )}

          {message && (
            <p className="text-base text-common-gray-6 font-normal">
              {message}
            </p>
          )}

          {action && <div className="mt-8">{action}</div>}
        </div>

        {eventId && (
          <p className="mt-16 text-base text-common-gray-7 font-normal">
            {t('errors:other.eventId', { id: eventId })}
          </p>
        )}
      </div>
    </main>
  )
}
